<template>
  <!-- 底部转化与联系信息区 -->
  <footer class="footer">
    <div class="container_2026">
      <!-- 转化按钮区 -->
      <div class="cta-buttons">

        <div class="buttons">
          <a href="https://www.cyberway.net.cn/contact" target="_blank" class="cta-button">AI 咨询</a>
          <a href="https://www.cyberway.net.cn/contact" target="_blank" class="cta-button">AI 标准化产品免费试用</a>
          <a href="https://www.cyberway.net.cn/contact" target="_blank" class="cta-button">企业业务 AI 化升级方案演示</a>
        </div>
      </div>

      <div class="footer-content">
        <!-- 联系信息区 -->
        <div class="contact-info">
          <h3>联系我们</h3>
          <div class="contact-section">
            <p class="contact-title">产品咨询</p>
            <p class="contact-value"><span class="highlight">400-168-0262</span></p>
          </div>
          <div class="contact-section">
            <p class="contact-title">市场合作</p>
            <p class="contact-value">020-82108862</p>
          </div>
          <div class="contact-section">
            <p class="contact-title">合作邮箱</p>
            <p class="contact-value">Marketing@cyberway.net.cn</p>
          </div>
        </div>

        <!-- 新媒体二维码区 -->
        <div class="social-qr">
          <p>AI 产品动态、行业干货实时更新</p>
          <div class="qr-codes">
            <div class="qr-code">
            <p>官方公众号</p>
            <img src="../assets/img/images/images3.jpg" alt="公众号二维码" class="qr-image">
          </div>
          <div class="qr-code">
            <p>官方视频号</p>
            <img src="../assets/img/images/images4.jpg" alt="视频号二维码" class="qr-image">
          </div>
          <div class="qr-code">
            <p>官方企微</p>
            <img src="../assets/img/images/images5.png" alt="企微二维码" class="qr-image">
          </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    jumpTo(url) {
      window.open(url);
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Footer.vue